import * as z from 'zod'
import { AggregatorOccupationCodeEnum } from '~/shared/config/enums'
import { ApiModel } from './core'

const schema = z.object({
  code: z.nativeEnum(AggregatorOccupationCodeEnum),
  title: z.string(),
})

export type AggregatorOccupationAttributes = z.infer<typeof schema>

export class AggregatorOccupation extends ApiModel<
  typeof schema,
  AggregatorOccupationAttributes
> {
  static jsonApiType = 'aggregator-occupations'

  static schema = schema

  getTitle(): string {
    return this.getAttribute('title')
  }
  getCode(): AggregatorOccupationCodeEnum {
    return this.getAttribute('code')
  }

  getOption(): {
    id: UniqueId
    label: string
    code: AggregatorOccupationCodeEnum
  } {
    return {
      id: this.getApiId() as UniqueId,
      label: this.getTitle(),
      code: this.getCode(),
    }
  }

  static async fetchOptions() {
    const response = await AggregatorOccupation.get(1)
    return response.getData().map((o) => o.getOption())
  }
}
